<template>
	<div>
		<header>
	        <a>
	            <div class="logo"></div>
	        </a>
	        <h3 class="title">东方号</h3>
	        <a class="message" @click="goMessage"></a>
	        <div class="person" @click="logOutClick"></div>
	        <ul v-if="logOutShow">
	            <li><a @click="RevisePwd">修改密码</a></li>
	            <li id="logOut"><a @click="logout">退出登录</a></li>
	        </ul>
	        <div class="user-main">
	            <div class="user-info">
	                <img class="user-pic" :src="userInfo.mediaHeadPic"/>
	                <div class="user-name">
	                    <h3>{{userInfo.mediaName}}</h3>
	                    <p>东方号指数<span>{{datadDesc.dfhgrade}}</span></p>
	                </div>
	                <span class="user-tag" v-if="userInfo.ulevel==1">新手作者</span>
	                <span class="user-tag" v-else-if="userInfo.ulevel==2">休闲作者</span>
	                <span class="user-tag" v-else-if="userInfo.ulevel==3">专业作者</span>
	                <span class="user-tag" v-else>大师作者</span>
	            </div>
	            <p class="main-title">{{userInfo.mediaDesc}}</p>
	        </div>
	        <img :src="userInfo.mediaHeadPic" class="blur img-blur"/>
	    </header>

	    <div class="main">
	        <div class="main-top">
	            <ul>
	                <li class="article"><a @click="noOpen($event)" href="javascript:;"><span></span>发布图文</a></li>
	                <!-- <li class="video">
                        <el-upload
                            class="avatar-videoUploader"
                            action=""
                            accept='.mp4,.mov,.flv'
                            :show-file-list="false"
                            :http-request='beforeAvatarVedioUpload'
                            >
                            <a href="javascript:;"><span></span>发布视频</a>
                        </el-upload>

	                	<a @click="goPagevideo"><span></span>发布视频</a>
	                </li> -->
	                <li class="imgs">
			            <el-upload
			                class="add-groupImgs"
			                :action="eatlasUploadUrl"
			                :before-upload="handleBefore"
			                :on-success="handleSuccess"
			                :on-error="handleError"
			                multiple
			                :show-file-list='false'
			                :file-list="fileList">
			                <label class="btn-image"><span></span>发布图集</label>
			            </el-upload>
	                	<!-- <a @click="goPageatlas"><span></span>发布图集</a> -->
	                </li>
	                <li class="article-list"><a @click="goPagearticlelist"><span></span>文章管理</a></li>
	                <li class="data-analyze"><a @click="noOpen($event)" href="javascript:;"><span></span>数据分析</a></li>
	            </ul>
	        </div>
	        <div class="sec-data">
	            <div class="title">数据简报</div>
	            <ul class="data-show">
	                <li>
	                    <h3>{{datadDesc.pv}}</h3>
	                    <p>总阅读量</p>
	                </li>
	                <li>
	                    <h3>{{datadDesc.uv}}</h3>
	                    <p>总评论量</p>
	                </li>
	                <li>
	                    <h3>{{datadDesc.realTimeFans}}</h3>
	                    <p>总粉丝量</p>
	                </li>
	                <li>
	                    <h3>{{datadDesc.num}}</h3>
	                    <p>已发表文章</p>
	                </li>
	            </ul>
	            <ul class="data-change-show">
	                <li>
	                    <div>
	                        <h3>{{tableUpdateData.pv_newly_inc}}</h3>
	                        <p>新增阅读量</p>
	                    </div>
	                    <div>
	                        <h3 :class="changeStatus.pv_inc_rat_status">{{tableUpdateData.pv_inc_rat}}</h3>
	                        <p>同比前日</p>
	                    </div>
	                </li>
	                <li>
	                    <div>
	                        <h3>{{tableUpdateData.cmt_newly_inc}}</h3>
	                        <p>新增评论量</p>
	                    </div>
	                    <div>
	                        <h3 :class="changeStatus.cmt_inc_rat_status">{{tableUpdateData.cmt_inc_rat}}</h3>
	                        <p>同比前日</p>
	                    </div>
	                </li>
	                <li>
	                    <div>
	                        <h3>{{tableUpdateData.flw_inc}}</h3>
	                        <p>新增粉丝量</p>
	                    </div>
	                    <div>
	                        <h3 :class="changeStatus.flw_inc_rat_status">{{tableUpdateData.flw_inc_rat}}</h3>
	                        <p>同比前日</p>
	                    </div>
	                </li>
	                <li>
	                    <div>
	                        <h3>{{tableUpdateData.share_inc}}</h3>
	                        <p>新增分享量</p>
	                    </div>
	                    <div>
	                        <h3 :class="changeStatus.share_inc_rat_status">{{tableUpdateData.share_inc_rat}}</h3>
	                        <p>同比前日</p>
	                    </div>
	                </li>
	                <li>
	                    <div>
	                        <h3>{{tableUpdateData.income_inc}}</h3>
	                        <p>新增收入额</p>
	                    </div>
	                    <div>
	                        <h3 :class="changeStatus.income_inc_rat_status">{{tableUpdateData.income_inc_rat}}</h3>
	                        <p>同比前日</p>
	                    </div>
	                </li>
	                <li>
	                    <div>
	                        <h3>{{tableUpdateData.cnum_inc}}</h3>
	                        <p>发表文章数</p>
	                    </div>
	                    <div>
	                        <h3 :class="changeStatus.cnum_inc_rat_status">{{tableUpdateData.cnum_inc_rat}}</h3>
	                        <p>同比前日</p>
	                    </div>
	                </li>
	            </ul>
	        </div>
	        <div>
			    <tab></tab>
	        </div>
	    </div>
	    <div v-if="progressShow" class="uploadMask">
	    	<h3>正在上传</h3>
	    	<p class="uploadMask-progress"><span></span></p>
	    </div>
	</div>
</template>
<script>
    import $ from 'jquery'
import Tab from './../components/homepage/tab.vue'
import {h5TabulateData, datatotal, logout, getuserinfo, uploadVideo, checkAppToken} from './../axios/api.js'
export default {
  		name: 'Homepage',
	  	components: {
		    Tab
	  	},
  		data () {
    return {
      			userInfo: { // 保存用户信息
      				mediaHeadPic: '',
      				mediaName: '',
      				mediaDesc: '',
      				ulevel: ''
      			},
      			tableUpdateData: {}, // 增量对比信息数据
      			changeStatus: {
      				pv_inc_rat_status: '',
			        cmt_inc_rat_status: '',
			        flw_inc_rat_status: '',
			        share_inc_rat_status: '',
			        income_inc_rat_status: '',
			        cnum_inc_rat_status: ''
      			},
      			datadDesc: {},
      			tabTitle: [
      				{title: '近期发布'},
      				{title: '推荐阅读'},
      				{title: '优质用户'}
  				],
  				logOutShow: false,
      imgList: [],
      fileList: [],
      eatlasUploadUrl: '',
      videoUploadUrl: '',
      videoUrl: '',
      imgLength: 0,
      progressShow: false
    }
  		},
  		mounted() {
    this.GetCheckAppToken();
        this.eatlasUploadUrl = 'http://' + window.location.host + '/picUpload';
            // this.videoUploadUrl = "http://"+window.location.host+'/uploadVideo';
    this.getRouteData();
    this.datatotal();
    this.h5TabulateData();
			// let that = this;
			// console.log(this);
  		},
  methods: {
    GetCheckAppToken () {
  checkAppToken(this.$route.query).then(result => {
    if (result.stat == 1) {
						// console.log(result);
} else {
    window.open('js-m-action://backToNotWebView');
}
  })
},
    logOutClick () {
  let logOutStatus = this.logOutShow;
  this.logOutShow = !logOutStatus;
},
    noOpen () {
      this.$layer.dialog({
        content: '功能尚未开放',
        time: 2000
      })
},
    getRouteData () {
				// 获取用户信息
				// if(this.$route.query.user.mediaHeadPic){
				// 	this.userInfo = this.$route.query.user;
				// }
  let that = this;
      getuserinfo().then(result => {
                	if (result.stat != 1) {
                		that.$router.push({path: '/Login'})
                		return;
                	}
        if (result.user) {
          that.userInfo = result.user;
          if (result.user.registstep != 3) {
            that.$router.push({path: '/RegistType'})
          }
        }
      })
    },
    goMessage () {
  this.$router.push({path: '/Message'})
},
    goPageatlas () {
  this.$router.push({path: '/EditImgList'})
},
    goPagevideo () {
  this.$router.push({path: '/Pagevideo'})
},
    goPagearticlelist () {
  this.$router.push({path: '/Pagearticlelist'})
},
    RevisePwd () {
  this.$router.push({path: '/RevisePwd'})
},
    h5TabulateData () {
  let that = this;
  h5TabulateData().then(result => {
    that.tableUpdateData = result;
					// 阅读量
    if (parseFloat(result.pv_inc_rat) > 0) {
    that.changeStatus.pv_inc_rat_status = 'add';
} else if (parseFloat(result.pv_inc_rat) < 0) {
    that.changeStatus.pv_inc_rat_status = 'reduce';
}
					// 评论量
    if (parseFloat(result.cmt_inc_rat) > 0) {
    that.changeStatus.cmt_inc_rat_status = 'add';
} else if (parseFloat(result.cmt_inc_rat) < 0) {
    that.changeStatus.cmt_inc_rat_status = 'reduce';
}
					// 粉丝量
    if (parseFloat(result.flw_inc_rat) > 0) {
    that.changeStatus.flw_inc_rat_status = 'add';
} else if (parseFloat(result.flw_inc_rat) < 0) {
    that.changeStatus.flw_inc_rat_status = 'reduce';
}
					// 分享量
    if (parseFloat(result.share_inc_rat) > 0) {
    that.changeStatus.share_inc_rat_status = 'add';
} else if (parseFloat(result.share_inc_rat) < 0) {
    that.changeStatus.share_inc_rat_status = 'reduce';
}
					// 收入额
    if (parseFloat(result.income_inc_rat) > 0) {
    that.changeStatus.income_inc_rat_status = 'add';
} else if (parseFloat(result.income_inc_rat) < 0) {
    that.changeStatus.income_inc_rat_status = 'reduce';
}
					// 文章数
    if (parseFloat(result.cnum_inc_rat) > 0) {
    that.changeStatus.cnum_inc_rat_status = 'add';
} else if (parseFloat(result.cnum_inc_rat) < 0) {
    that.changeStatus.cnum_inc_rat_status = 'reduce';
}
  })
},
    datatotal () {
  let that = this;
  datatotal().then(result => {
    if (result && result.stat == 1) {
    that.datadDesc = result;
} else if (result.stat == 0) {
    that.$router.push({path: '/Login'})
}
  })
},
    logout () {
  let that = this;
  logout().then(result => {
    if (result.stat == 1) {
			            that.$router.push({path: '/Login'})
			        }
  })
},
        handleBefore (file) {
          console.log(file);
          this.progressShow = true;
        },
        handleSuccess (response, file, fileList) {
            	let imgListLength = this.imgLength;
            	if (response.error == 0) {
	                let fileData = {
	                    name: file.name,
	                    desc: '',
	                    url: response.urls[0].src
	                }
	                this.imgList.push(fileData);
	                this.imgLength = imgListLength + 1;
            	} else {
	                this.$layer.dialog({
	                    content: '上传失败，请重新尝试',
	                    time: 2000
	                })
	                return;
            	}
          this.progressShow = false;
            	if (this.imgLength == fileList.length) {
              this.$router.push({path: '/EditImgList', query: {imgList: this.imgList}});
            	}
        },
        handleError (err, file, fileList) {
          this.$layer.dialog({
            content: '上传失败，请重新尝试',
            time: 2000
          })
        },
	      	coverClick (e) {
	      		e.preventDefault();
	      		$(e.target).closest('.add-groupImgs').find('input').click();
	      	},
	      	videoClick (e) {
	      		e.preventDefault();
	      		$(e.target).closest('.avatar-videoUploader').find('input').click();
	      	},

            // 视频上传
        beforeAvatarVedioUpload(res) {
          let cts = '', rtds = '';// 用来判断视频是否是重新上传
            	let that = this;
            	let file = res.file;
            	let Bucket = 'gxtest';
                // console.log(file);
          let name = file.name; // 文件名
          let size = file.size; // 总大小
          let content_type = file.type;
          let Header = {
            'Content-Type': content_type,
            'Content-Length': size
          };
          let _data = file.slice(0, size);
          let params = {
            'Bucket': Bucket,
            'METHOD': 'PUT',
            'Header': Header,
            'Key': name,
	                'cts': cts,
	                'rdts': rtds
          }
          let extendName = name.substring(name.lastIndexOf('.') + 1);
          let limitType = 'mp4,mov,flv';
          if (limitType.indexOf(extendName) == -1) {
    this.$layer.toast({
					  	className: 'videoType', // 图标clssName 如果为空 toast位置位于下方,否则居中
					  	content: '视频格式不对,请上传mp4,flv,mov视频',
					  	time: 2000 // 自动消失时间 toast类型默认消失时间为2000毫秒
})
    return;
          }
          if (size > 500 * 1024 * 1024) {
    this.$layer.toast({
					  	className: 'videoType', // 图标clssName 如果为空 toast位置位于下方,否则居中
					  	content: '视频文件过大',
					  	time: 2000 // 自动消失时间 toast类型默认消失时间为2000毫秒
})
    return;
          }

          this.progressShow = true;
          let isAuth = uploadVideo(params).then(res => {
			  		if (res.stat == '1') {
        let data = res.data;
			  			let vurl = 'http://' + Bucket + '.ufile.ucloud.cn/' + res.data.newFileName;
		                $.ajax({
                      url: vurl,
                      type: 'PUT',
                      processData: false,
                      contentType: false,
                      async: false,
                      data: _data,
                      headers: {
                        'Authorization': res.data.auth,
                        'Content-Type': content_type
                      },
                      success: function(response, textStatus, jqXHR) {
                        if (jqXHR.status == '200') {
                          console.log(response);
                          that.videoUrl = vurl;
                          data.videoUrl = vurl;
                          that.progressShow = false;
                          that.$layer.dialog({
										  	title: '提示', // 第一个是标题内容  第二个是标题栏的style(可以为空)
										  	content: '上传成功',
										  	btn: ['确定']
                          }).then(function() {
                            that.$router.push({path: '/Pagevideo', query: {videoUrl: that.videoUrl, videoData: data}})
                          })
                        } else {
                          that.$layer.toast({
										  	className: 'videoType', // 图标clssName 如果为空 toast位置位于下方,否则居中
										  	content: '上传失败，请重新尝试',
										  	time: 2000 // 自动消失时间 toast类型默认消失时间为2000毫秒
                          })
                        }
                      }
                    });

			                return true;
			  		} else {
			  			 return false;
			  		}
			  	});
        }
  }
}
</script>
<style scoped>
	@import "./../common/css/homepage.css";
	.imgs .btn-image {
		color: #666;
	}
	.uploadMask{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(66, 66, 66, 0.6);
	}
	.uploadMask h3{
		position: absolute;
		top: 47%;
		left: 0;
		width: 100%;
		text-align: center;
		font-size: 0.36rem;
		color: #fff;
		z-index: 100;
	}
	.uploadMask .uploadMask-progress{
		position: absolute;
		top: 49%;
		left: 0;
		width: 100%;
		text-align: center;
		z-index: 100;
	}
	.uploadMask .uploadMask-progress span{
		display: inline-block;
		width: 66px;
		height: 6px;
		background: url('./../assets/img/upload-loading.gif');
		background-size: cover;
	}
</style>



// WEBPACK FOOTER //
// src/pages/AppHomepage.vue